import { render, staticRenderFns } from "./ClientOrdersTable.vue?vue&type=template&id=6e1f2540&"
import script from "./ClientOrdersTable.vue?vue&type=script&lang=js&"
export * from "./ClientOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrdersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports